var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.globalAdherence == 0)?_c('div',{},[_c('div',{staticClass:"headers"},[_c('div',{staticClass:"global-adherence-header"},[_vm._v(_vm._s(_vm.$t("aderencia-global-0")))]),_c('div',{staticClass:"global-adherence-value"},[_vm._v(" "+_vm._s(_vm.globalAdherence ? _vm.globalAdherence + " %" : "-")+" ")])])]):_c('div',{staticClass:"all"})
}
var staticRenderFns = []

export { render, staticRenderFns }